// Centralized backend URL resolution — environment-aware at runtime
//
// Rules:
//   1. Production (browser on onlymass.net)      → https://onlymass.net
//   2. Preview   (browser on *.preview.emergentagent.com) → use REACT_APP_BACKEND_URL or window origin
//   3. Fallback                                   → REACT_APP_BACKEND_URL or window origin
//
// This ensures the production bundle NEVER calls a preview backend,
// regardless of what was baked into REACT_APP_BACKEND_URL at build time.

const PRODUCTION_HOST = 'onlymass.net';
const PRODUCTION_URL = 'https://onlymass.net';

function resolveBackendUrl() {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  // Rule 1: If running on production, always use production backend
  if (hostname === PRODUCTION_HOST || hostname.endsWith('.' + PRODUCTION_HOST)) {
    return PRODUCTION_URL;
  }

  // Rule 2 & 3: Preview or local — use env var or window origin
  return process.env.REACT_APP_BACKEND_URL
    || process.env.REACT_APP_BASE_URL
    || (typeof window !== 'undefined' ? window.location.origin : '');
}

export const BACKEND_URL = resolveBackendUrl();
export const API_URL = BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
